/**
 * mock测试用的一些功能接口
 */
import { IMSDK } from '@/imsdk/index.ts';
const imsdk = IMSDK.create();

export default {
  mounted() {
    // setTimeout(() => {
    //   // 新消息
    //   this.mockNewMsg();
    // }, 500);

    // setTimeout(() => {
    //   // 历史消息
    //   this.mockHistoryMsg();
    // }, 3000);

    // setTimeout(() => {
    //   this.mockSecNewMsg();
    // }, 5000);
  },

  methods: {
    // mock 收到新消息推送
    mockNewMsg() {
      // 模拟发送个当前用户。
      const to = this.to.id;
      const msgList = {
        [to]: [
          {
            seq: 1646037310050750,
            type: 'text',
            time: 1646037310050,
            status: 0,
            from: to,
            content: '33',
          },
          {
            seq: 1646043597458311,
            type: 'text',
            time: 1646037310080,
            status: 0,
            to,
            content: '33👋😓',
          },
          {
            seq: 1646043603692382,
            type: 'ptt_info',
            time: 1646037310090,
            status: 2,
            to,
            content: 'blob:http://localhost:8080/b5c15a8f-b357-4d2a-9c52-8df0f5369947',
            uuid: 'blob',
            length: 3,
            size: 3829,
          },
          {
            seq: 1646043614889413,
            type: 'image',
            time: 1646037310100,
            status: 3,
            to,
            content: 'https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-189792930-E59538E23B28257858A4768105725293/0',
            uuid: 'blob',
            name: '6-71.jpg',
            size: 246076,
            width: 1080,
            height: 1080,
          },
          {
            seq: 1646043620941012,
            type: 'file_info',
            time: 1646037310150,
            status: 1,
            to,
            content: 'blob:http://localhost:8080/a1b9bb6c-3210-419d-b46b-862b6546954d',
            uuid: 'blob',
            name: '1-167.jpg',
            size: 162356,
            format: 'image/jpeg',
          },
          {
            seq: 1646043614889499,
            type: 'image',
            time: 1646037319999,
            status: 1,
            from: to,
            content: 'https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1407385184-A6EAA9C108A9B70BBC28E401A0AF09BC/0',
            uuid: 'blob',
            name: '6-72.jpg',
            size: 246076,
            width: 1080,
            height: 1080,
          },
        ],
      };

      imsdk.emit(IMSDK.EVENT.MESSAGE_RECEIVED, msgList);
    },

    // mock二次消息
    mockSecNewMsg() {
      const to = this.to.id;
      const msgList = {
        [to]: [
          {
            seq: 1646037310050751,
            type: 'text',
            time: Date.now() - 10000,
            status: 0,
            from: to,
            content: '33',
          },
          {
            seq: 16460436148897231,
            type: 'image',
            time: Date.now(),
            status: 1,
            from: to,
            content: 'https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1407385184-A6EAA9C108A9B70BBC28E401A0AF09BC/0',
            uuid: 'blob',
            name: '6-72.jpg',
            size: 246076,
            width: 1080,
            height: 1080,
          },
        ],
      };

      imsdk.emit(IMSDK.EVENT.MESSAGE_RECEIVED, msgList);
    },

    // 模拟历史消息
    mockHistoryMsg() {
      const to = this.to.id;
      const msgList = [
        {
          seq: 1646049603074836,
          type: 'text',
          time: 1646049603074,
          status: 0,
          to,
          content: '32425235👍😨😅99999"',
        },
        {
          seq: 1646049617420695,
          type: 'image',
          time: 1646049617428,
          status: 0,
          from: to,
          content: 'https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1852158553-52F4133DF330089B5767114625CE99C8/0',
          uuid: 'blob',
          name: '6-72.jpg',
          size: 246076,
          width: 1080,
          height: 1080,
        },
      ];

      this.recoverScrollbarAfterPullHistoryMsg();

      // 直接调用addmsg模拟
      this.addMessageList({ ...msgList[0] }, 1, true);
      this.addMessageList({ ...msgList[1] }, 1, false);
    },
  },
};
